<style scoped>

  @media only screen and (min-width: 991px) {
    .charts-grid {
      margin-top: -15px !important;
    }
  }

</style>

<template>
  
  <div>

    <div class="ui large breadcrumb">
      <div class="section">
        <strong>Página Inicial</strong>
      </div>            
    </div>

    <div class="ui divider"></div>

    <div class="ui grid">
      <div class="eight wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="grey text">{{ welcomeMessage }}</div>  
      </div>
      <div v-if="pendingRequestsLabel" class="eight wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic segment no-margin no-padding animated flash" :class="{ 'right aligned': $isDesktop }">
          <div class="ui orange label clickable" @click="$router.push('/procs/cert-complement-requests')">
            <i class="info circle icon"></i> {{ pendingRequestsLabel }}
          </div>
        </div>
      </div>
    </div>

    <div class="ui grid charts-grid">
      <div class="eight wide computer sixteen wide tablet sixteen wide mobile column">
        <notes /> 
      </div>
      <div class="eight wide computer sixteen wide tablet sixteen wide mobile column">
        <certs-pie /> 
      </div>
      <div v-if="$isSimavet()" class="eight wide computer sixteen wide tablet sixteen wide mobile column">
        <birthdays />
      </div>
    </div>

  </div>

</template>

<script>

  import moment from "@/utils/moment"
  import Notes from "./notes.vue"
  import Birthdays from "./birthdays.vue"
  import CertsPie from "./certs-pie.vue"  
  import CertComplementRequestService from "@/services/cert-complement-request-service"

  export default {

    name: "HomePage",

    data() {
      return {
        pendingRequests: 0,
      }
    },

    components: {
      Notes,
      Birthdays,
      CertsPie,
    },

    created() {
      this.getPendingRequests()
    },
    
    computed: {

      welcomeMessage() {

        if (!this.$store.state.auth.user)
          return ""

        const hour = parseInt(moment().format("HH"))
        let message = ""

        if (hour >= 5 && hour <= 11) {
          message = "Bom dia"
        } else if (hour >= 12 && hour <= 18) {
          message = "Boa tarde"
        } else {
          message = "Boa noite"
        }

        message += ", " + this.$store.state.auth.user.name.trim() + " !"

        return message
      },

      pendingRequestsLabel() {

        if (this.pendingRequests == 0)
          return ""

        let label = ""

        if (this.pendingRequests == 1) {
          label = "Você possui uma solicitação de complemento pendente"
        } else {
          label = `Você possui ${this.pendingRequests} solicitações de complemento pendentes`
        }

        return label
      }
    },

    methods: {

      async getPendingRequests() {
        
        try {

          const service = new CertComplementRequestService()

          this.pendingRequests = await service.countUserPendingRequests(this.$store.state.auth.user.id)
          
        } catch (error) {
          this.$errorHandler(error)
        }
      },
    },
  }

</script>